<template>
  <div id="page-events">
    <h5 class="m-4 page-header"> >> {{ $t('AUTH.MENU.EVENT') }}</h5>

    <EventEditorModal 
      ref="event-editor-modal"
      :event_id="selected_event_id"

      @updated="updated_event"
      @created="created_event"
      @recurring_created="recurring_created"
    />

    <MemberEditorCompactModal
      ref="member-editor-compact-modal-tab"
      :member_id="member_id"

      @created="member_created"
      @updated="member_updated"
      @deleted="member_deleted"
    />

    <memlist-card>
      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <EventsTable

              ref="events-table"
              @create_event_clicked="create_event_clicked"
              @publish_event_clicked="publish_event_clicked"
              @select_event_clicked="select_event_clicked"
              
            />

          </div>
          <div v-show="active_tab === 1">
            <EventCategory
              class="mt-8"
              @eventCategoryDeleted="eventCategoryDeleted"
              @eventCategoryCreated="eventCategoryCreated"
            />
          </div>
          <div v-show="active_tab === 2">
            <EventSettings />
          </div>
        </div>
      </div>
    </memlist-card>
  </div>
</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import EventEditorModal from '@/view/pages/ml/events/EventEditorModal.vue';
import EventsTable from '@/view/pages/ml/events/EventsTable.vue';

import EventCategory from '@/view/pages/ml/event_category/EventCategory.vue';
import EventSettings from '@/view/pages/ml/events/EventSettings.vue';
import Companies from './Companies.vue';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';


import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';
import AttributeGroupSelectButton from '@/view/components/attribute_group_selector/AttributeGroupSelectButton.vue';

export default {
  name: 'EventsPage',
  components: {
    EventsTable,
    EventEditorModal,
    Companies,
    
    EventCategory,
    EventSettings,
    RightSaveButton,
    AttributeGroupSelectButton
  },
  emits: ['cancel'],
  mixins: [ toasts ],
  computed: {
    status_options() {
      return [
        { text: this.$t('EVENT.STATUSES.DRAFT'), value: 'DRAFT' },
        { text: this.$t('EVENT.STATUSES.ACTIVE'), value: 'ACTIVE' },
        { text: this.$t('EVENT.STATUSES.ARCHIVED'), value: 'ARCHIVED' },

      ];
    },
    ...mapGetters(['companies', 'currentCompanyId', 'currentPeriodId']),

    valid_ticket_email_template() {
      return this.form.ticket_template_id !== null;
    }
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      selected_event_id: null,
      active_tab: 0,
      tabs: [
        { label: 'EVENT.EVENTS' },
        { label: 'EVENT.CATEGORIES' },
        { label: 'COMMON.SETTINGS' }
      ],

      
      member_event: {},
      member_id: null,
      activetab_href_variable: 0,
      showMemberEventEditor: false,
      member_event_id: null,
      event_categories_options: [],
      edit_lng: null,
      edit_lat: null,
      member_events_copy: null,
      textFilter: null,
      toDelete: null,
      memberEventToDelete: null,
      memberEvent: null,

      showHistory: false,
      hasGoogleMaps: false,
      cost_group_member: false,
      collapse_book_vat_acct: false,
      collapse_url_group: false,
      form: {
        vat_option: 'INC_VAT',
        group_ids: [],
        use_deadline: false,
        location_descr: null,
        location_setting: 'NONE',
        max_tickets_per: 1,
        event_id: null,
        num_strikes_orgs: 9999999,
        num_strikes_max: 9999999,
        num_seats: 0,
        num_signups: 0,
        num_strike_days: 0,
        strike_template_id: '',
        strike_system: false,
        members_only: true,
        public_only: false,
        sms_template_id: '',
        send_sms_invite: false,
        email_template_id: '',
        send_email_invite: false,
        signedup_template_id: '',
        ticket_template_id: '',
        cost_non_members: 0,
        cost: 0,
        extern_url: '',
        facebook_url: '',
        to_datetime: '',
        from_datetime: '',
        postaladdress: '',
        zipcode: '',
        address: '',
        descr: '',
        name: '',
        type: 'NONE',
        book_acct_first: 0,
        book_acct_second: 0,
        google_maps: { lat: 0, lng: 0, static_link: '' },
        book_tags: [],
        book_acct: '',
        book_vat_acct: '',
        book_cost_center: '',
        notif_user_ids: [],
        open_setting: 'ANY_MEMBER',
      },
      member_events: [],
      creating: false,
      editing: false,
      addressok: false,
      zipcodeok: false,
      postaladdressok: false,
      generateGoogle: false,
      showInfo: false,
      events: [],
      event_headers: [
        {
          key: 'ts_signup',
          label: this.$t('COMMON.DATE'),
          sortable: true,
          formatter: (_, __, item) => {
            return item.ts_signup;
          },
        },
        {
          key: 'company',
          label: this.$t('MEMBER.COMPANY_NAME')
        },
        {
          key: 'shop_order_id',
          label: this.$t('SHOP_ORDER.PAY_REF'),
          formatter: (_, __, item) => {
            return item.shop_order_id;
          },
        },
        {
          key: 'checkedin',
          label: this.$t('EVENT.CHECKEDIN'),
          sortable: false,
          formatter: (_, __, item) => {
            return item.checkedin ? this.$t('COMMON.YES') : this.$t('COMMON.NO')
          },
        },
        {
          key: 'firstname',
          label: this.$t('COMMON.NAME'),
          formatter: (_, __, item) => {

            const m = item.person !== null && item.person !== undefined ? item.person : item.member;

            if (m.cname) {
              return m.cname + ' ' + m.firstname + ' ' + m.lastname;
            }

            return m.firstname + ' ' + m.lastname;
          },
          sortable: false
        },
        {
          key: 'email',
          label: this.$t('MEMBER.EMAIL'),
          formatter: (_, __, item) => {

            const m = item.person !== null && item.person !== undefined ? item.person : item.member;

            if (m.email) {
              return m.email;
            }

            return '';
          },
        },
        {
          key: 'telefon',
          label: this.$t('MEMBER.MOBILE'),
          formatter: (_, __, item) => {

            const m = item.person !== null && item.person !== undefined ? item.person : item.member;

            if (m.phone) {
              return m.phone;
            }

            return '';
          },
        },
        {
          key: 'hantera',
          label: this.$t('COMMON.ACTIONS')
        }
      ],

      infoWIndowContext: {
        position: {
          lat: 44.2899,
          lng: 11.8774
        }
      },
      infoWindowsList: []
    };
  },
  watch: {
    'edit_lat'(newValue) {
      if (!newValue) {
        return;
      }
      const lat = parseFloat((newValue+'').replace(/,/g, '.'));

      if (isNaN(lat)) {
        console.error('nan');
      }
      else {
        this.form.google_maps.lat = lat;
      }
    },
    'edit_lng'(newValue) {
      if (!newValue) {
        return;
      }

      const lng = parseFloat((newValue+'').replace(/,/g, '.'));

      if (isNaN(lng)) {
        console.error('nan');
      }
      else {
        this.form.google_maps.lng = lng;
      }
    },
    'form.location_setting'(newValue) {
      if (newValue === 'NONE') { this.form.type = 'NONE'; }
      else if (newValue === 'ONLINE') { this.form.type = 'ONL'; }
      else { this.form.type = 'PHY'; }
    },
    textFilter(newValue) {
      if (newValue && newValue.length < 3) {
        this.member_events = this.member_events_copy;

        return;
      }

      this.member_events = this.member_events_copy.filter(item => item.search.indexOf(newValue) >= 0);

    },

    currentCompanyId(newValue, oldvalue) {
      if (newValue) {
        // close event editor
        this.editing = false;
        this.creating = false;
        this.$refs['events-table'].refresh();
      }
    }
  },
  methods: {
    recurring_created(events) {
      this.$refs['events-table'].refresh();
    },
    updated_event(item) {
      this.$refs['events-table'].refresh();
    },


    created_event(item) {
      this.selected_event_id = item.event_id;
      this.$refs['events-table'].refresh();
    },
    
    create_event_clicked() {
      this.selected_event_id = null;
      this.$refs['event-editor-modal'].show();
    },
    select_event_clicked(event_id) {
      this.selected_event_id = event_id;
      this.$nextTick(()=>{
        this.$refs['event-editor-modal'].show();
      });
    },
    publish_event() {
      this.form.status = 'ACTIVE';
      this.save_event();

    },

    archive_event() {
      this.form.status = 'ARCHIVED';
      this.save_event();
    },

    member_created(member) {},
    member_updated(member) {},
    member_deleted(member_id) {},

    member_selected(member_id) {
      this.member_id = member_id;
      this.$refs['member-editor-compact-modal-tab'].show(member_id);
    },

    property_groups_selected(group_ids) {
      this.form.group_ids = group_ids;
      this.form = { ...this.form }

      console.log('groups selected', group_ids);
    },

    on_submit() {

      this.save_event();
    },

    onNotifEmailsSelected(notif_user_ids) {
      this.form.notif_user_ids = notif_user_ids;
    },
    updated_member_event(member_event) {
      const index = this.member_events.findIndex(item => item.member_event_id === member_event.member_event_id);

      if (index >= 0) {
        this.member_events[index] = member_event;
        this.member_events = [ ...this.member_events ];
      }

      // when event was changed
      if (this.form.event_id !== member_event.event_id) {
        this.member_events.splice(index, 1);
        this.member_events = [ ...this.member_events ];
      }

    },
    created_member_event(memberEvent) {

      this.member_events.push({ ...memberEvent,
        id: memberEvent.member_event_id,
        ts_signup: memberEvent.ts_signup,
        shop_order_id: memberEvent.shop_order_id,
        firstname: memberEvent.member ? memberEvent.member.firstname : memberEvent.person.firstname,
        lastname: memberEvent.member ? memberEvent.member.lastname : memberEvent.person.lastname,
        email: memberEvent.member ? memberEvent.member.email : memberEvent.person.email,
        telefon: memberEvent.member ? memberEvent.member.phone : memberEvent.person.phone,
        hantera: ''
      } );

      this.member_events = [ ...this.member_events ]

      this.toastr('success', this.$t('COMMON.OK'), this.$t('EVENT.MEMBER_PERSON_ADDED'));
    },
    eventCategoryDeleted(id) {
      this.event_categories_options = this.event_categories_options.filter(item => item.id !== id);
    },
    eventCategoryCreated(event_category) {
      this.event_categories_options.push({
        value: event_category.id,
        text: event_category.name
      });
    },

    exportXlsxClicked() {
      axios
        .post(`/member_event/xlsx/${this.form.event_id}`, {})
        .then(res => {
          if (res.status === 201) {
            downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
          }
          else if (res.status === 403) {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
          }
          else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.UNABLE_CREATE_FILE'));
          }
        })
        .catch(err => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PAGES.FILES.UNABLE_CREATE_FILE'));
          console.error(err);
        });
    },
    async loadData() {

      if (!this.currentCompanyId) {
        return;
      }
      
      this.loadEventCategories();
    },
    
    publish_event_clicked(event_id) {},
    
    
    publishEvent(e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.editing = false;
      this.creating = false;
      this.scrollToClassName('scroll-to-top');
    },


    loadEventCategories() {
      axios
        .get(`/event_category`)
        .then(res => {
          if (res.status === 200) {

            this.event_categories_options = [];

            for (const ec of res.data) {
              this.event_categories_options.push({
                value: ec.id,
                text: ec.name
              });
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  }
};
</script>
